import React from "react";
import { Button, ThemeProvider } from "@ts-digital/vrc";
import { notification } from "antd";
import { FormattedMessage } from "react-intl";

const messageNotification = ({ navigate, setIsResetUpload, textMessage}) => {  
  return (
    <ThemeProvider>
      <div>
        {textMessage}
        <div style={{ textAlign: "right", marginTop: "32px" }}>
          <Button
            kind={"secondary"}
            colorScheme={"ghost"}
            onClick={e => {
              notification.destroy();
              setIsResetUpload(true);
            }}
            style={{ marginRight: "16px" }}
          >
            <FormattedMessage id="actions.close" />
          </Button>
          <Button
            kind={"primary"}
            onClick={e => {
              navigate("/documenti");
              notification.destroy();
            }}
          >
            <FormattedMessage id="actions.goDocuments" />
          </Button>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default messageNotification;
